export const VehicleErrorsConst = {
    modal:{
        DRIV025: "El conductor es requerido",
        VEHI014: "El vehículo es requerido",
        VEHI013: "El vehículo no es válido",
        DRIV026: "El conductor ya está asignado a un vehículo",
    },
    default: "Ocurrió un error",
  };